import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { FaPlus, FaMinus, FaEdit, FaTrash } from "react-icons/fa";
import "./LeaveTracker.css";
import api from "../services/api";

export default function LeavePTOTracker() {
  const { id: businessId } = useParams();
  const [policyType, setPolicyType] = useState(""); // PTO policy selection
  const [existingPolicies, setExistingPolicies] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);
  const [completionPeriods, setCompletionPeriods] = useState([
    { period: "90 days", hourlyVacationHours: "", salaryVacationHours: "", hourlyVacationCap: "" },
  ]);

  useEffect(() => {
    const fetchVacationPolicy = async () => {
      try {
        const response = await api.get(`/vacation-policy/${businessId}`);
        if (response.data.length > 0) {
          setExistingPolicies(response.data);
        }
      } catch (error) {
        console.error("Error fetching PTO policy:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVacationPolicy();
  }, [businessId]);

  const savePTOPolicy = async () => {
    if (!policyType || completionPeriods.length === 0) {
      alert("Please select a policy type and add at least one completion period.");
      return;
    }
  
    try {
      await api.post("/vacation-policy", {
        businessId,
        policyType,
        completionPeriods,
      });
  
      alert("PTO Policy Saved Successfully!");
      // Fetch updated policies so the screen switches to the results view
    const response = await api.get(`/vacation-policy/${businessId}`);
    setExistingPolicies(response.data); // 🔹 This will trigger the results screen
    } catch (error) {
      alert("Failed to save PTO policy. Try again.");
      console.error("Save PTO Policy Error:", error);
    }
  };

  // Add a new completion period
  const addCompletionPeriod = () => {
    setCompletionPeriods([...completionPeriods, { period: "1 year", hourlyVacationHours: "", salaryVacationHours: "" }]);
  };

  // Remove a completion period
  const removeCompletionPeriod = (index) => {
    if (completionPeriods.length > 1) {
      setCompletionPeriods(completionPeriods.filter((_, i) => i !== index));
    }
  };

    // Function to update a specific completion period field
  const updateCompletionPeriod = (index, key, value) => {
    const updatedPeriods = [...completionPeriods];
    updatedPeriods[index][key] = value;
    setCompletionPeriods(updatedPeriods);
  };



  const handleEditClick = (policy) => {
    if (editingRow === policy.id) {
      setEditingRow(null); // Clicking again cancels edit mode
    } else {
      setEditingRow(policy.id);
      setEditData({
        policy_type: policy.policy_type,
        completion_period: policy.completion_period,
        hourly_vacation_hours: policy.hourly_vacation_hours || "",
        hours_cap: policy.hours_cap || "",
        salary_vacation_hours: policy.salary_vacation_hours || "",
      });
    }
  };
  
  

  // Handle edit input changes
  const handleEditChange = (key, value) => {
    setEditData((prev) => ({ ...prev, [key]: value }));
  };

  // Submit edited PTO policy
  const handleEditSubmit = async (policyId) => {
    try {
      await api.put(`/vacation-policy/${policyId}`, editData);
      alert("PTO Policy Updated!");
      setEditingRow(null);
      const response = await api.get(`/vacation-policy/${businessId}`);
      setExistingPolicies(response.data);
    } catch (error) {
      console.error("Error updating PTO policy:", error);
      alert("Failed to update PTO policy.");
    }
  };

  // Delete PTO policy
  const handleDelete = async (policyId) => {
    if (!window.confirm("Are you sure you want to delete this PTO policy?")) return;

    try {
      await api.delete(`/vacation-policy/${policyId}`);
      alert("PTO Policy Deleted!");
      const response = await api.get(`/vacation-policy/${businessId}`);
      setExistingPolicies(response.data);
    } catch (error) {
      console.error("Error deleting PTO policy:", error);
      alert("Failed to delete PTO policy.");
    }
  };

  if (loading) {
    return <p className="text-center mt-5">Loading PTO policies...</p>;
  }

  return (
    <div className="leave-pto-container-existing">
      {existingPolicies.length > 0 ? (
        <div className="existing-pto">
          <h2>Existing Leave & PTO Policies</h2>
          <table className="policy-table">
          <thead>
            <tr>
              <th>Policy Type</th>
              <th>Completion Period</th>
              {existingPolicies.some((policy) => policy.policy_type === "accrual") ? (
                <>
                  <th>Hours per Pay Period (Hourly Employees)</th>
                  <th>Max Hour Cap</th>  {/* 🔹 Add Hour Cap column for accrual policies */}
                  <th>Hours per Pay Period (Salary Employees)</th>
                </>
              ) : (
                <>
                  <th>Hours (Hourly Employees)</th>
                  <th>Hours (Salary Employees)</th>
                </>
              )}
              <th className="leave-action">Actions</th>
            </tr>
          </thead>

            <tbody className="existing-pto-body">
              {existingPolicies.map((policy) => (
                <>
                  <tr key={policy.id} className="view-row-pto">
                    <td>{policy.policy_type}</td>
                    <td>{policy.completion_period}</td>
                    <td>{policy.hourly_vacation_hours || "N/A"}</td>
                    {policy.policy_type === "accrual" && (
                      <td>{policy.hours_cap || "N/A"}</td>
                    )}
                    <td>{policy.salary_vacation_hours || "N/A"}</td>
                    <td>
                      <FaEdit className="edit-icon" onClick={() => handleEditClick(policy)} />
                      <FaTrash className="delete-icon" onClick={() => handleDelete(policy.id)} />
                    </td>
                  </tr>
                  {editingRow === policy.id && (
                <tr className="edit-row-pto">
                  <td></td>
                  <td className="edit-completion-select">
                    <select className="edit-select-option"
                      value={editData.completion_period}
                      onChange={(e) => handleEditChange("completion_period", e.target.value)}
                    > 
                      <option value="">Select Period</option>
                      <option value="90 days">90 days</option>
                      <option value="1 Year">1 Year</option>
                      <option value="2 year">2 Years</option>
                      <option value="3 year">3 Years</option>
                      <option value="5+ years">5+ Years</option>
                    </select>
                  </td>
                  
                  {/* Hourly Vacation Hours Input */}
                  <td className="edit-hours-input">
                    <input
                      type="number"
                      value={editData.hourly_vacation_hours}
                      onChange={(e) => handleEditChange("hourly_vacation_hours", e.target.value)}
                    />
                  </td>

                  {/* Hour Cap Input (Show Only If Policy Type is Accrual) */}
                  {editData.policy_type === "accrual" && (
                    <td className="edit-hours-cap">
                      <input
                        type="number"
                        placeholder="Max Hourly PTO Cap"
                        value={editData.hours_cap}
                        onChange={(e) => handleEditChange("hours_cap", e.target.value)}
                      />
                    </td>
                  )}

                  {/* Salary Vacation Pay Input */}
                  <td className="edit-salary-input">
                    <input
                      type="number"
                      value={editData.salary_vacation_hours}
                      onChange={(e) => handleEditChange("salary_vacation_hours", e.target.value)}
                    />
                  </td>

                  <td>
                    <button className="submit-btn-pto" onClick={() => handleEditSubmit(policy.id)}>
                      Submit
                    </button>
                  </td>
                </tr>
              )}

                </>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="leave-pto-container">
      <h2>Leave & PTO Tracker Setup</h2>
      <p>Choose how you want to handle leave and paid time off (PTO) for your employees.</p>

      {/* PTO Policy Selection */}
      <label>Select PTO Policy</label>
      <select className="select-box-pto" value={policyType} onChange={(e) => setPolicyType(e.target.value)}>
        <option value="">Select an option</option>
        <option value="accrual">Accrual-Based PTO</option>
        <option value="fixed">Fixed PTO</option>
      </select>

      {policyType === "fixed" && (
        <div>
          <h3>Employment Completion Periods</h3>
          {completionPeriods.map((entry, index) => (
            <div key={index} className="completion-period">
              <div className="form-grid main-pto-sel">
                {/* Completion Period Selection */}
                <select
                  value={entry.period}
                  onChange={(e) => updateCompletionPeriod(index, "period", e.target.value)}
                > <option value="">Select Period</option>
                  <option value="1 year">1 Year</option>
                  <option value="2 year">2 Years</option>
                  <option value="3 year">3 Years</option>
                  <option value="5+ years">5+ Years</option>
                </select>

                {/* Hourly Employees - Set Vacation Hours */}
                <input
                  type="number"
                  placeholder="Hourly Vacation Hours"
                  value={entry.hourlyVacationHours}
                  onChange={(e) => updateCompletionPeriod(index, "hourlyVacationHours", e.target.value)}
                />

                {/* Salaried Employees - Set Vacation Pay */}
                <input
                  type="number"
                  placeholder="Salary Vacation Hours"
                  value={entry.salaryVacationHours}
                  onChange={(e) => updateCompletionPeriod(index, "salaryVacationHours", e.target.value)}
                />
              </div>

              {/* Add & Remove Icons BELOW the row */}
              <div className="icon-buttons-pto">
                {index > 0 && (
                  <FaMinus className="minus-icon-pto" onClick={() => removeCompletionPeriod(index)} />
                )}
                {index === completionPeriods.length - 1 && (
                  <FaPlus className="plus-icon-pto" onClick={addCompletionPeriod} />
                )}
              </div>
            </div>
          ))}
        </div>
      )}


      {policyType === "accrual" && (
        <div>
          <h3>Employment Completion Periods</h3>
          {completionPeriods.map((entry, index) => (
            <div key={index} className="completion-period">
              <div className="form-grid main-pto-sel">
                {/* Completion Period Selection */}
                <select
                  value={entry.period}
                  onChange={(e) => updateCompletionPeriod(index, "period", e.target.value)}
                >
                  <option value="90 days">90 Days</option>
                  <option value="1 year">1 Year</option>
                  <option value="2 year">2 Years</option>
                  <option value="3 year">3 Years</option>
                  <option value="5+ years">5+ Years</option>
                </select>

                {/* Hourly Employees - Set Vacation Hours */}
                <input
                  type="number"
                  placeholder="Hourly Vacation Hours per Pay Period"
                  value={entry.hourlyVacationHours}
                  onChange={(e) => updateCompletionPeriod(index, "hourlyVacationHours", e.target.value)}
                />

                {/* Hourly Employees - Set Vacation Hours Cap */}
                <input
                  type="number"
                  placeholder="Max Hourly PTO Cap"
                  value={entry.hourlyVacationCap}
                  onChange={(e) => updateCompletionPeriod(index, "hourlyVacationCap", e.target.value)}
                />

                {/* Salaried Employees - Set Vacation Pay */}
                <input
                  type="number"
                  placeholder="Salary Vacation Hours per Pay Period"
                  value={entry.salaryVacationHours}
                  onChange={(e) => updateCompletionPeriod(index, "salaryVacationHours", e.target.value)}
                />
              </div>

              {/* Add & Remove Icons BELOW the row */}
              <div className="icon-buttons-pto">
                {index > 0 && (
                  <FaMinus className="minus-icon-pto" onClick={() => removeCompletionPeriod(index)} />
                )}
                {index === completionPeriods.length - 1 && (
                  <FaPlus className="plus-icon-pto" onClick={addCompletionPeriod} />
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <button className="save-btn-pto" onClick={savePTOPolicy}>
      Save PTO Policy
      </button>

    </div>
      )}
    </div>
  );
}



// import { useState } from "react";
// import { useParams } from "react-router-dom";
// import { FaPlus, FaMinus } from "react-icons/fa"; // Import icons
// import "./LeavePTOTracker.css";
// import api from "../services/api";

// export default function LeavePTOTracker() {
//   const { id: businessId} = useParams();
//   const [policyType, setPolicyType] = useState(""); // PTO policy selection
//   const [completionPeriods, setCompletionPeriods] = useState([
//     { period: "1 year", hourlyVacationHours: "", salaryVacationPay: "" },
//   ]);


//   const savePTOPolicy = async () => {
//     if (!policyType || completionPeriods.length === 0) {
//       alert("Please select a policy type and add at least one completion period.");
//       return;
//     }
  
//     try {
//       await api.post("/vacation-policy", {
//         businessId,
//         policyType,
//         completionPeriods,
//       });
  
//       alert("PTO Policy Saved Successfully!");
//     } catch (error) {
//       alert("Failed to save PTO policy. Try again.");
//       console.error("Save PTO Policy Error:", error);
//     }
//   };
  
  
  
  

//   // Function to add a new completion period entry
//   const addCompletionPeriod = () => {
//     setCompletionPeriods([
//       ...completionPeriods,
//       { period: "1 year", hourlyVacationHours: "", salaryVacationPay: "" },
//     ]);
//   };

//   // Function to delete the most recent completion period entry
//   const removeCompletionPeriod = (index) => {
//     if (completionPeriods.length > 1) {
//       const updatedPeriods = completionPeriods.filter((_, i) => i !== index);
//       setCompletionPeriods(updatedPeriods);
//     }
//   };

//   // Function to update a specific completion period field
//   const updateCompletionPeriod = (index, key, value) => {
//     const updatedPeriods = [...completionPeriods];
//     updatedPeriods[index][key] = value;
//     setCompletionPeriods(updatedPeriods);
//   };

//   return (
//     <div className="leave-pto-container">
//       <h2>Leave & PTO Tracker Setup</h2>
//       <p>Choose how you want to handle leave and paid time off (PTO) for your employees.</p>

//       {/* PTO Policy Selection */}
//       <label>Select PTO Policy</label>
//       <select className="select-box" value={policyType} onChange={(e) => setPolicyType(e.target.value)}>
//         <option value="">Select an option</option>
//         <option value="accrual">Accrual-Based PTO</option>
//         <option value="fixed">Fixed PTO</option>
//         <option value="none">No PTO Policy</option>
//       </select>

//       {policyType === "fixed" && (
//         <div>
//           <h3>Employment Completion Periods</h3>
//           {completionPeriods.map((entry, index) => (
//             <div key={index} className="completion-period">
//               <div className="form-grid">
//                 {/* Completion Period Selection */}
//                 <select
//                   value={entry.period}
//                   onChange={(e) => updateCompletionPeriod(index, "period", e.target.value)}
//                 >
//                   <option value="1 year">1 Year</option>
//                   <option value="2 years">2 Years</option>
//                   <option value="3 years">3 Years</option>
//                   <option value="4 years">4 Years</option>
//                   <option value="5+ years">5+ Years</option>
//                 </select>

//                 {/* Hourly Employees - Set Vacation Hours */}
//                 <input
//                   type="number"
//                   placeholder="Hourly Vacation Hours"
//                   value={entry.hourlyVacationHours}
//                   onChange={(e) => updateCompletionPeriod(index, "hourlyVacationHours", e.target.value)}
//                 />

//                 {/* Salaried Employees - Set Vacation Pay */}
//                 <input
//                   type="number"
//                   placeholder="Salary Vacation Pay"
//                   value={entry.salaryVacationPay}
//                   onChange={(e) => updateCompletionPeriod(index, "salaryVacationPay", e.target.value)}
//                 />
//               </div>

//               {/* Add & Remove Icons BELOW the row */}
//               <div className="icon-buttons">
//                 {index > 0 && (
//                   <FaMinus className="minus-icon" onClick={() => removeCompletionPeriod(index)} />
//                 )}
//                 {index === completionPeriods.length - 1 && (
//                   <FaPlus className="plus-icon" onClick={addCompletionPeriod} />
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       <button className="save-btn" onClick={savePTOPolicy}>
//       Save PTO Policy
//       </button>;

//     </div>
//   );
// }





// import { useState } from "react";

// export default function LeavePTOTracker() {
//   const [policyType, setPolicyType] = useState(""); // PTO policy selection

//   return (
//     <div className="max-w-3xl mx-auto p-6">
//       <div className="border rounded-lg shadow-md p-6">
//         <h2 className="text-xl font-semibold mb-4">Leave & PTO Tracker Setup</h2>
//         <p className="text-sm text-gray-600 mb-4">
//           Choose how you want to handle leave and paid time off (PTO) for your employees.
//         </p>

//         {/* PTO Policy Selection */}
//         <label htmlFor="pto-policy" className="block font-medium">Select PTO Policy</label>
//         <select
//           id="pto-policy"
//           className="border p-2 rounded w-full mt-2"
//           value={policyType}
//           onChange={(e) => setPolicyType(e.target.value)}
//         >
//           <option value="">Select an option</option>
//           <option value="accrual">Accrual-Based PTO</option>
//           <option value="fixed">Fixed PTO</option>
//           <option value="none">No PTO Policy</option>
//         </select>

//         {/* Dynamic Fields Based on Selection */}
//         {policyType === "accrual" && (
//           <div className="mt-4 space-y-3">
//             {/* Hourly Employees - Accrual */}
//             <label htmlFor="accrual-hours" className="block font-medium">Accrual Rate (Hours per Pay Period)</label>
//             <input id="accrual-hours" type="number" placeholder="e.g., 2.5" className="border p-2 rounded w-full" />

//             {/* Salaried Employees - Accrual */}
//             <label htmlFor="accrual-dollar" className="block font-medium">PTO Dollar Amount per Pay Period</label>
//             <input id="accrual-dollar" type="number" placeholder="e.g., 500" className="border p-2 rounded w-full" />

//             <label htmlFor="carryover" className="block font-medium">Allow Carryover?</label>
//             <select id="carryover" className="border p-2 rounded w-full">
//               <option value="yes">Yes, with limit</option>
//               <option value="no">No, use it or lose it</option>
//             </select>
//           </div>
//         )}

//         {policyType === "fixed" && (
//           <div className="mt-4 space-y-3">
//             {/* Hourly Employees - Fixed */}
//             <label htmlFor="fixed-hours" className="block font-medium">Annual PTO Amount (Hours)</label>
//             <input id="fixed-hours" type="number" placeholder="e.g., 80" className="border p-2 rounded w-full" />

//             {/* Salaried Employees - Fixed */}
//             <label htmlFor="fixed-dollar" className="block font-medium">Annual PTO Dollar Amount</label>
//             <input id="fixed-dollar" type="number" placeholder="e.g., 5000" className="border p-2 rounded w-full" />

//             <label htmlFor="carryover-fixed" className="block font-medium">Allow Carryover?</label>
//             <select id="carryover-fixed" className="border p-2 rounded w-full">
//               <option value="yes">Yes, with limit</option>
//               <option value="no">No, use it or lose it</option>
//             </select>
//           </div>
//         )}

//         <button className="mt-6 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition">
//           Save PTO Policy
//         </button>
//       </div>
//     </div>
//   );
// }
